<template>
  <el-dialog :title="title" :visible.sync="editVisible" width="450px" :before-close="handleClose" :close-on-click-modal="false" center>
    <div class="from-body">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="auto" class="demo-ruleForm">
        <el-form-item label="固件类别">
          <el-select v-model="ruleForm.stype" placeholder="请选择" style="width:300px;">
            <el-option label="模块" :value=10 />
            <el-option label="边缘网关" :value=20 />
            <el-option label="边缘服务器" :value=30 />
          </el-select>
        </el-form-item>
        <el-form-item label="固件名称" prop="name">
          <el-input v-model="ruleForm.name" style="width:300px;" clearable/>
        </el-form-item>
        <el-form-item label="固件版本" prop="version">
          <el-input v-model="ruleForm.version" style="width:300px;" clearable/>
        </el-form-item>
        <el-form-item label="文件校验" prop="fileCrc">
          <el-input v-model="ruleForm.fileCrc" style="width:300px;" clearable/>
        </el-form-item>
        <el-form-item label="文件大小" prop="fileSize">
          <el-input v-model="ruleForm.fileSize" style="width:300px;" clearable/>
        </el-form-item>
        <el-form-item label="启用状态" prop="status">
          <el-select v-model="ruleForm.status" placeholder="请选择" style="width:300px;">
            <el-option label="启用" :value=10 />
            <el-option label="禁用" :value=20 />
          </el-select>
        </el-form-item>
        <el-form-item label="上传固件" prop="fileUrl">
          <DiluUploadFile :limit="2" :fileList="fileList"  @remove="removeFile" @success="successFile"/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button @click="submit" type="primary">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DiluUploadFile from "@/components/public/dilu-uploadfile.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      title: "新增固件",
      ruleForm: {
         id: null,
         stype: 10,
         name: "",
         version: "",
         status: 10,
         fileUrl: "[]",
         fileCrc: "",
         fileSize: 0,
      },
      rules: {
        stype: [
          {
            required: true,
            message: "请设置固件类别",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请填写固件名称",
            trigger: "blur",
          },
        ],
        version: [
          {
            required: true,
            message: "请填写固件版本号",
            trigger: "blur",
          },
        ],
        fileSize: [
          {
            required: true,
            message: "请填写固件字节数",
            trigger: "blur",
          },
        ],
        fileCrc: [
          {
            required: true,
            message: "请填写固件校验码",
            trigger: "blur",
          },
        ],
        fileUrl: [
          {
            required: true,
            message: "请上传升级固件",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请填设置固件状态",
            trigger: "blur",
          },
        ],
      },
      fileList: [],
    };
  },
  components: {
    DiluUploadFile
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  props: ["editVisible","firmwareItem","editStatus"],
  watch: {
    editVisible(newValue) {
      if (newValue) {
        if (this.editStatus==0) {
          this.title="新增固件";
          this.ruleForm={
            id: null,
            stype: 10,
            name: "",
            version: "",
            status: 10,
            fileUrl: "[]",
            fileCrc: "",
            fileSize: 0,
          };
        } else {
          this.title="编辑固件";
          this.ruleForm={
            id: this.firmwareItem.id,
            stype: this.firmwareItem.stype,
            name: this.firmwareItem.name,
            version: this.firmwareItem.version,
            status: this.firmwareItem.status,
            fileUrl: this.firmwareItem.fileUrl,
            fileCrc: this.firmwareItem.fileCrc,
            fileSize: this.firmwareItem.fileSize,
          };
          var fileUrl=this.ruleForm.fileUrl;
          this.fileList=[];
          if (fileUrl!=null&&fileUrl!=undefined&&fileUrl!='') {
            this.fileList=JSON.parse(fileUrl);
          } else {
            this.ruleForm.fileUrl="[]";
          }
        }
      }
    },
  },
  methods: {
    onInput() {
      this.$forceUpdate();
    },
    handleClose() {
      this.ruleForm={
        id: null,
        stype: 10,
        name: "",
        version: "",
        status: 10,
        fileUrl: "[]",
        fileCrc: "",
        fileSize: 0,
      };
      this.$emit("handleClose");
    },
    submit() {
      if (this.ruleForm.fileUrl=="[]") {
        this.$message.error("至少上传一个升级固件");
      } else {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            if (this.editStatus==0) {
              this.request.addFirmwareDtu(this.ruleForm).then((res) => {
                if (res.code==0) {
                  this.$message.success("添加成功");
                  this.handleClose();
                }
              });
            } else if (this.editStatus==1) {
              this.request.editFirmwareDtu(this.ruleForm).then((res) => {
                if (res.code==0) {
                  this.$message.success("修改成功");
                  this.handleClose();
                }
              });
            }
          }
        });
      }
    },
    removeFile(e) {
      const i = this.fileList.findIndex((x) => x.name == e);
      this.fileList.splice(i, 1);
      var fileUrl=JSON.parse(this.ruleForm.fileUrl);
      fileUrl.splice(i, 1);
      this.ruleForm.fileUrl = JSON.stringify(fileUrl);
    },
    successFile(e) {
      this.fileList=e.fileList;
      var fileUrl=JSON.parse(this.ruleForm.fileUrl);
      var item={};
      item.url=e.url;
      item.name=e.name;
      fileUrl.push(item);
      this.ruleForm.fileUrl = JSON.stringify(fileUrl);
    },
  },
};
</script>
<style scoped>
</style>